import React from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

/**
 * ToggleButton component displays a button that toggles between active and inactive states.
 *
 * @param {object} props - Component props.
 * @param {string} [props.activeText='On'] - Text to display when active.
 * @param {string} [props.className=''] - Additional CSS class names.
 * @param {string} [props.inactiveText='Off'] - Text to display when inactive.
 * @param {boolean} [props.isActive=false] - Current active state.
 * @param {Function} [props.onChangeCallback] - Callback invoked with new state on toggle.
 */
function ToggleButton({
  activeText = 'On',
  className = '',
  inactiveText = 'Off',
  isActive = false,
  onChangeCallback = () => {},
}) {
  const buttonText = isActive ? activeText : inactiveText;

  return (
    <button
      className={classNames(
        styles.button,
        className,
        { [styles.isActive]: isActive },
      )}
      data-testid="toggle--button"
      onClick={() => {
        const newState = !isActive;
        onChangeCallback(newState);
      }}
      type="button"
    >
      <span className={styles.buttonText} data-testid="toggle--button--text">
        {buttonText}
      </span>
      <span className={classNames(styles.arrow, 'icon icon-angle-down')} />
    </button>
  );
}

export { ToggleButton };
